export default __webpack_public_path__ + "static/media/travel.4b29172a.jpg";